import { NgoCardView } from './NgoCard.view';
import React from 'react';
export const NgoCard = ({ ngo, handleClickNgo, selectedNgo }) => {
  return (
    <NgoCardView
      ngo={ngo}
      handleClickNgo={handleClickNgo}
      selectedNgo={selectedNgo}
    />
  );
};
